import frankulaUIVid from "../../../../src/video/frankula-UI.mp4";
import * as React from 'react';
export default {
  frankulaUIVid,
  React
};